/**
 * @param {HTMLElement} Content
 */
export const addLoading = (Content) => {
  const { top, left, width, height } = Content.getBoundingClientRect()
  const Placeholder = document.createElement('div')
  Placeholder.style.position = 'absolute'
  Placeholder.style.top = `${top + window.pageYOffset}px`
  Placeholder.style.left = `${left + window.pageXOffset}px`
  Placeholder.style.width = `${width}px`
  Placeholder.style.height = `${height}px`
  Placeholder.style.background = 'rgba(255,255,255,0.75)'
  Placeholder.style.zIndex = 99999
  const Loader = document.createElement('div')
  Loader.style.textAlign = 'center'
  Loader.style.width = '100%'
  const SplendidLoader = document.getElementById('SplendidLoader')
  let innerHtml = '<span class="SplendidLoader">Loading…</span>'
  if (SplendidLoader) {
    /** @type {HTMLElement} */
    const c = SplendidLoader.cloneNode(false)
    c.style.display = ''
    innerHtml = c.outerHTML
  }
  Loader.innerHTML = innerHtml
  Placeholder.appendChild(Loader)
  document.body.insertBefore(Placeholder, document.body.firstChild)
  return Placeholder
}